<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { ref } from 'vue';


let items = ref([
    "Handrub Solutions"
]);

let images = ref([
    "36.webp",
    "37.webp",
    "38.webp",
    "39.webp",
    "40.webp",
]);



</script>

<template>
   <main class="w-full h-auto my-2">

    <section class="container mx-auto h-auto flex flex-col justify-start items-center">
      <span class="font-bold text-xl">Products / Specialized Hospital Antibacterial Anti Fungal Solutions</span>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">
        <div :key="index" class="w-full h-full col-span-1 flex justify-center items-center" v-for="(item,index) in items">
            <div class="w-3 h-3 bg-sky-500 rounded-full"></div>
            <span class="mx-2">{{ item }}</span>
        </div>
      </section>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">

        <a :key="index" download :href="`/Specializedhospital/${item}`"  v-for="(item,index) in images" class="w-full h-[250px] rounded-lg col-span-1 flex justify-center items-center">
            <img  :src="`/Specializedhospital/${item}`" class="w-full h-full object-contain " alt="">
        </a>

      </section>

    </section>
  </main>
</template>

<style scoped></style>